module.exports = __webpack_public_path__ + "static/media/search.d615e75a.svg";